// extracted by mini-css-extract-plugin
export default {"box":"formlabels_box__HWCdD","input":"formlabels_input__4DhDP","label":"formlabels_label__ZcTNH"};